<template>
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login" v-if="show">
				<div v-if="step == 1">
					<div class="title">支付订单</div>
					<div class="order flex-center flex-between">
						<div class="order-left flex-start flex-center">
							<img src="@/assets/images/pay/pay.png"/>
							<div class="order-left-text">
								<div>提交成功！请尽快完成支付。</div>
								<div>请在 <el-statistic :value="new Date(info.cancelTime)" format="HH时mm分ss秒" time-indices @finish="toOrderInfo"></el-statistic> 内完成支付,超时后将取消订单</div>
							</div>
						</div>
						
						<div class="order-right">
							<div>应付总额: </div>
							<div>￥{{info.meetPrice}}</div>
						</div>
					</div>
					
					<div class="title">选择以下支付方式付款</div>
					
					<div class="pay">
						<div class="pay-title">支付平台</div>
						<div class="pay-list flex-start flex-center">
							
							<div class="pay-list-item flex-center flex-midden" :class="pay == 4?'active':''" @click="changePay(4)">
								<img src="@/assets/images/pay/icon4.png"/>
								<div>信用付</div>
								<img class="pay-list-item-icon" v-if="pay == 4" src="@/assets/images/pay/dui4.png"/>
							</div>
							<div class="pay-list-item flex-center flex-midden" :class="pay == 1?'active':''" @click="changePay(1)">
								<img src="@/assets/images/xianxia.png"/>
								<div>线下付款</div>
								<img class="pay-list-item-icon" v-if="pay == 1" src="@/assets/images/pay/dui4.png"/>
							</div>
							
						</div>
						
						<div v-if="pay == 4" class="pay-four">
							信用额度：<span>{{account}}</span>
						</div>
						
						
						<div v-if="pay ==1" class="pay-four">
							打款截图：
							<div class="image-list flex-start flex-center flex-wrap">
								<div v-for="(item,index) in image" :key="index" class="image-list-item">
									<img :src="item"/>
									<img  src="@/assets/images/close.png" class="icon-close" @click="image.splice(index,1)"/>
								</div>
								<el-upload :action="$apiBase + '/system/upload'" accept="image/*" ref="uploadFile" :on-success="successImage" :limit="1">
									
									<div class="image-list-add">
										<img src="@/assets/images/add2.png"/>
										<div>选择图片</div>
									</div>
								</el-upload>
							</div>
						</div>
						
						<el-button v-if="pay == 4" class="pay-button" :loading="isSubmit" @click="submitOrder">立即支付</el-button>
						<el-button v-if="pay == 1" class="pay-button" :loading="isSubmit" @click="submitInfo">提交</el-button>
					</div>
				</div>
				
				
				
				
				<div v-if="step == 2 && pay == 4">
					<div class="title">支付成功</div>
					<div class="pay-success">
						<img src="@/assets/images/pay/pay.png"/>
						<div class="success-title">订单支付成功</div>
						<div class="success-msg">我们将尽快为您发货，收货期间请保持手机畅通</div>
						<div class="success-msg">支付方式：<span>信用付</span></div>
						<div class="success-msg">支付金额：<span>￥{{info.meetPrice}}</span></div>
						
						<div class="success-button flex-midden flex-center">
							<div @click="toIndex()">进入首页</div>
							<div @click="toOrderInfo">查看订单</div>
						</div>
					</div>
				</div>
				<div v-if="step == 2 && pay == 1">
					<div class="title">提交成功</div>
					<div class="pay-success">
						<img src="@/assets/images/pay/pay.png"/>
						<div class="success-title">订单提交成功</div>
						<div class="success-msg">我们将尽快为您审核，请耐心等待</div>
						<div class="success-msg">支付方式：<span>线下付款</span></div>
						<div class="success-msg">支付金额：<span>￥{{info.meetPrice}}</span></div>
						
						<div class="success-button flex-midden flex-center">
							<div @click="toIndex()">进入首页</div>
							<div @click="toOrderInfo">查看订单</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getBatchPay,getUserInfo,batchCreatePay,savePaymentImage} from "@/api/user"
	export default {
		data(){
			return {
				info:{},
				id:0,
				show:false,
				step:1,
				pay:4,
				account:0,
				isSubmit:false,
				image:[]
			}
		},
		mounted() {
			this.id = this.$route.query.id || 0;
			this.$store.dispatch('fetchUser');
			this.getInfo();
			this.changePay(4);
		},
		methods:{
			getInfo(){
				getBatchPay({batchPayId:this.id}).then(res=>{
					if(res.code == 1000){
						this.info = res.data;
						this.show = true;
						this.step = 1;
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			successImage(e){
				if(e.code == 1000){
					this.image.push(e.data);
				}
				this.$refs.uploadFile.clearFiles();
			},
			changePay(type){
				this.pay = type;
				//获取个人信用积分
				if(this.pay == 4){
					this.account = this.$store.state.user.remainingCreditLimit;
				}
			},
			submitOrder(){
				this.isSubmit = true;
				batchCreatePay({
					batchPayId:this.id,
					payType:1
				}).then(res=>{
					if(res.code == 1000){
						this.step = 2;
					}else{
						this.isSubmit = false;
						return this.$message.error(res.message);
					}
				})
			},
			submitInfo(){
				if(this.image == ""){
					return this.$message.error("请上传支付截图");
				}
				this.isSubmit = true;
				batchCreatePay({
					batchPayId:this.id,
					payType:2,
					paymentImage:this.image.join(",")
				}).then(res=>{
					if(res.code == 1000){
						this.step = 2;
					}else{
						this.isSubmit = false;
						return this.$message.error(res.message);
					}
				})
			},
			toOrderInfo(){
				this.$router.replace("/userorder");
			},
			toIndex(){
				this.$router.replace("/");
			}
		}
	}
</script>
<style scoped lang="scss">
	.pay-success{
		width: 1320px;
		background: #FFFFFF;
		text-align: center;
		padding: 80px 0px;
		img{
			width: 120px;
			height: 120px;
		}
		.success-title{
			font-size: 32px;
			font-weight: 500;
			line-height: 46px;
			color: #070B13;
			margin-top: 30px;
		}
		.success-msg{
			font-size: 20px;
			color: rgba(7, 11, 19, 0.6);
			margin-top: 12px;
			line-height: 28px;
			span{
				color: #E91A12;
			}
		}
		.success-button{
			margin-top: 60px;
			div{
				width: 191px;
				height: 46px;
				border: 1px solid rgba(233, 26, 18, 0.3);
				font-size: 16px;
				line-height: 46px;
				color: #070B13;
				text-align: center;
				margin: 0px 10px;
				cursor: pointer;
				&:first-of-type{
					color: #fff;
					background-color: #E91A12;
					border-color: #E91A12;
				}
			}
		}
	}
	.pay{
		width: 1320px;
		background: #FFFFFF;
		padding: 0px 40px 30px;
		box-sizing: border-box;
		.pay-four{
			margin-top: 40px;
			font-size: 20px;
			color: #9C9DA1;
			span{
				color: #E91A12;
			}
		}
		.pay-button{
			width: 240px;
			height: 56px;
			background: #E91A12;
			font-size: 20px;
			font-weight: 500;
			letter-spacing: 0em;
			text-align: center;
			color: #FFFFFF;
			margin: 30px 0px 0px 0px;
			border: 0px;
		}
		.pay-title{
			font-size: 16px;
			font-weight: 500;
			line-height: 82px;
			color: #070B13;
		}
		.pay-list{
			.pay-list-item{
				width: 240px;
				height: 56px;
				border: 1px solid rgba(7, 11, 19, 0.1);
				cursor: pointer;
				margin-right: 20px;
				position: relative;
				img{
					width: 32px;
					height: 32px;
					margin-right: 12px;
				}
				div{
					color: #070B13;
					font-size: 18px;
				}
				.pay-list-item-icon{
					position: absolute;
					width: 32px;
					height: 32px;
					bottom: 0px;
					right: 0px;
					margin: 0px;
				}
			}
			.active{
				border: 1px solid rgba(233, 26, 18, 1);
			}
		}
	}
	::v-deep .el-statistic{
		display: inline;
	}
	::v-deep .el-statistic .con{
		display: inline;
		color: rgba(233, 26, 18, 1);
		span{
			font-size: 18px;
		}
	}
	.order{
		width: 1320px;
		background: #FFFFFF;
		padding: 60px 80px;
		box-sizing: border-box;
		.order-right{
			div{
				text-align: right;
				&:first-of-type{
					font-size: 16px;
					color: #070B13;
				}
				&:last-of-type{
					font-size: 32px;
					font-weight: 500;
					line-height: 40px;
					color: #E91A12;
					margin-top: 8px;
				}
			}
		}
		.order-left{
			img{
				width: 120px;
				height: 120px;
				flex: 0 0 120px;
				margin-right: 40px;
			}
			.order-left-text{
				div{
					&:first-of-type{
						font-size: 32px;
						font-weight: 500;
						line-height: 45px;
						color: #070B13;
					}
					&:last-of-type{
						font-size: 18px;
						font-weight: 500;
						line-height: 28px;
						color: rgba(7, 11, 19, 0.6);
						margin-top: 12px;
					}
				}
			}
		}
	}
	.title{
		font-size: 16px;
		font-weight: 500;
		line-height: 62px;
		color: #070B13;
	
	}
	.image-list{
		margin-top: 20px;
		.image-list-add{
			width: 106px;
			height: 106px;
			border: 1px dashed rgba(0, 0, 0, 0.4);
			padding: 30px 0px 30px;
			box-sizing: border-box;
			text-align: center;
			margin: 0px 16px 16px 0px;
			img{
				width: 24px;
				height: 24px;
			}
			div{
				font-size: 12px;
				line-height: 16px;
				color: #070B13;
				margin-top: 8px;
			}
		}
		.image-list-item{
			width: 108px;
			height: 108px;
			position: relative;
			margin: 0px 16px 16px 0px;
			img{
				width: 108px;
				height: 108px;
				object-fit: cover;
			}
			.icon-close{
				width: 16px;
				height: 16px;
				position: absolute;
				top: 0px;
				right: 0px;
			}
		}
	}
</style>